export { useIsMobile } from "./use-is-mobile.hook";
